import { Injectable } from '@angular/core';
import { User } from '../../models/user';
import { Role } from 'src/app/constants/role';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
const ID_KEY = 'auth-id';

@Injectable({
  providedIn: 'root',
})
export class TokenStorageService {
  constructor() { }

  signOut(): void {
    window.sessionStorage.clear();
  }

  public saveToken(token: string): void {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string | null {
    return window.sessionStorage.getItem(TOKEN_KEY);
  }

  public saveUser(user: User): void {
    window.sessionStorage.removeItem(USER_KEY);
    window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): any {
    const user = window.sessionStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }

    return {};
  }

  public hasRoles(roles: number[]): boolean {
    const user: User = this.getUser();
    return user.userRoles.some((userRole) =>
      roles.some((role) => role === userRole.roleId)
    );
  }

  isSuperadmin() {
    const user: User = this.getUser();
    return user.userRoles.some((role) => role.roleId === Role.SUPERADMIN);
  }

  isAdminCuti() {
    const user: User = this.getUser();
    return user.userRoles.some((role) => role.roleId === Role.ADMIN_CUTI);
  }

  isAdminKepegawaian() {
    const user: User = this.getUser();
    return user.userRoles.some((role) => role.roleId === Role.ADMIN_KEPEGAWAIAN);
  }

  isAnyAdmin() {
    return this.isSuperadmin() || this.isAdminCuti() || this.isAdminKepegawaian();
  }

  isPNS() {
    const user: User = this.getUser();
    return user.userRoles.some((role) => role.roleId === Role.PNS);
  }

  getId(): string {
    const user: User = this.getUser();
    return user.id!;
  }
}
